import { render, staticRenderFns } from "./WaitingListNotConfigured.vue?vue&type=template&id=3071a96c&scoped=true&"
import script from "./WaitingListNotConfigured.vue?vue&type=script&lang=js&"
export * from "./WaitingListNotConfigured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3071a96c",
  null
  
)

export default component.exports